export const mesesDelAnio = {
    "enero": 0,
    "febrero": 1,
    "marzo": 2,
    "abril": 3,
    "mayo": 4,
    "junio": 5,
    "julio": 6,
    "agosto": 7,
    "septiembre": 8,
    "octubre": 9,
    "noviembre": 10,
    "diciembre": 11,
}

export const tipoDeMedio = {
    "television": 1,
    "radio": 2,
    "escritos": 3,
    "pantallas": 4,
    "vallasFijas": 5,
    "vallasMoviles": 6,
}

export const tiposMedios = {
    TELEVISION: {id: 1, name: "TELEVISIÓN"},
    RADIO: {id: 2, name: "RADIO"},
    ESCRITOS: {id: 3, name: "ESCRITOS"},
    EXTERIOR: {id: 4, name: "MEDIOS ALTERNATIVOS"},
}

export const tiposMediosPorID = {
    1: {id: 1, name: "TELEVISIÓN"},
    2: {id: 2, name: "RADIO"},
    3: {id: 3, name: "ESCRITOS"},
    4: {id: 4, name: "MEDIOS ALTERNATIVOS"},
}

export const tipoDeClasificaionRadio = {
    4: {id: 4, name: "RADIO AM"},
    5: {id: 5, name: "RADIO FM"},
    10: {id: 10, name: "RADIO AM Y FM"},
}

export const tiposDeMediosEscritos = {
    1: {id: 1, name: "PERIÓDICO"},
    2: {id: 2, name: "REVISTA"},
}

export const tiposDeMediosExterior = {
    4: {id: 4, name: "VALLAS DIGITALES"},
    5: {id: 5, name: "VALLAS FIJAS"},
    6: {id: 6, name: "VALLAS MÓVILES"},
    7: {id: 7, name: "PÁGINAS WEB"},
}

export const catalogoFormularios = {
    "REGISTRO_PARA_INSCRIPCION": 1,
    "TARIFARIOS_Y_DISPONIBILIDAD_MEDIOS": 2,
    "MEDIOS_ALTERNATIVOS": 3,
    "PLAN_MEDIOS_ALTERNATIVOS": 4,
    "ELABAROCACION_PLAN_MEDIOS": 5,
    "PLAN_MEDIOS_INTEGRADO": 6
}

export const catalogoEventoElectoral = {
    "PRIMERA_VUELTA": 1,
    "SEGUNDA_VUELTA": 2,
    "POSIBLE_REPETICIÓN": 3
}

export const eventoElectoral = 1; //PRIMERA_VUELTA
export const eventoElectoralSegunda = 1; // SEGUNDA_VUELTA

export const catalogoDeCandidaturas = {
    PRESIDENTE: {value: 1, label: "Presidencia"},
    DIPUTACIONES: {value: 2, label: "Diputaciones"},
    CORPORACIONES: {value: 3, label: "Corporaciones"}
}

export const catalogoDeCandidaturasEleccion = {
    PRESIDENTE: 1,
    CORPORACIONES: 2,
    DIPUTACIONES: 3,
}

export const candidaturasEleccion = {
    1: "PRESIDENTE",
    2: "CORPORACIONES MUNICIPALES",
    3: "DIPUTACIONES",
}

export const tipoReporteVallasYPantalla = {
    "pantalla_digital_con_valor": 1,
    "vallas_moviles": 2,
    "vallas_fijas": 3,
}

export const solicitudEmpresaEscritosRequest = {
    "tipoDeMedioEscrito": 0,
    "idTipoCirculacionDeMedio": 0,
    "tieneSitioWeb": true,
    "sitioWeb": "string",
 }

export const solicitudEmpresaExteriorRequest = {
    "esPantalla": false,
    "esValla": false,
    "tieneAutorizacionMunicipal": false
}

export const solicitudEmpresaRadioRequest = {
    "radioAM": true,
    "radioFM": true,
    "numeroDeCertificacionSit": "string",
    //"numeroDeOrdenSit": "string",
    //"numeroDeRegistroSit": "string",
    "fechaVigenciaHastaSit": "dd-MM-yyyy",
    "pdfConstanciaSit": "string",
}

export const solicitudEmpresaTelevisionRequest = {
    // TV POR CABLE
    "idTipoDeTelevision": 0,
    "numeroCertificacionUncosu": "string",
    //"numeroOrdenUncosu": "string",
    //"numeroRegistroUncosu": "string",
    "fechaVigenciaHastaUncosu": "dd-MM-yyyy",
    "pdfConstanciaUncosu": "string",

    //  TV ABIERTA
    "numeroCertificacionSit": "string",
    //"numeroOrdenSit": "string",
    //"numeroRegistroSit": "string",
    "fechaVigenciaHastaSit": "dd-MM-yyyy",
    "pdfConstanciaSit": "string",

    // TV SATELITAL
    "licenciaDeOperacionDeFacilidades": true,
    "numeroDeOrdenSatelital": "string",
    "numeroDeRegistroSatelital": "string",
    "fechaVigenciaHastaSatelital": "dd-MM-yyyy",
    "pdfConstanciaLicenciaSatelital": "string",
}

export const estadosSolicitudEmpresa = {
    1: {id: 1, label: "PRE REGISTRO DIGITAL"},
    2: {id: 2, label: "PRESENTACION DEL EXPEDIENTE FISICO"},
    3: {id: 3, label: "ANALISIS"},
    4: {id: 4, label: "INSCRITO"},
    5: {id: 5, label: "RECHAZADAS"},
    6: {id: 6, label: "ENVIADA A CORRECCIÓN"},
    7: {id: 7, label: "GUARDADA COMO REVISADA"},
    8: {id: 8, label: "ENVIADA PARA APROBACIÓN"},
    9: {id: 9, label: "NO INSCRITO"},
    10: {id: 10, label: "SOLICITUD CORREGIDA"}
}

export const coberturasPorNombre = {
    NACIONAL: {id: 1, label: "NACIONAL"},
    REGIONAL: {id: 2, label: "REGIONAL"},
    DEPARTAMENTAL: {id: 3, label: "DEPARTAMENTAL"},
    MUNICIPAL: {id: 4, label: "MUNICIPAL"}
}